import { render, staticRenderFns } from "./AssignCall.vue?vue&type=template&id=32b055bb"
import script from "./AssignCall.vue?vue&type=script&lang=js"
export * from "./AssignCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports